/**
 * Hindi bhava / sign ordinals - digit form (1ला … 12वाँ) via hindiDigitOrdinal.
 * Oblique counting: 1ले … 12वें via hindiDigitOrdinalOblique.
 */
import {
  hindiBhavaOrdinal,
  hindiDigitOrdinal,
  hindiDigitOrdinalOblique,
  houseOrdinalDigitHi,
  houseOrdinalDigitObliqueHi,
} from '../utils/hindiDigitOrdinal';

export { houseOrdinalDigitHi, houseOrdinalDigitObliqueHi, hindiDigitOrdinal, hindiDigitOrdinalOblique };

/** @param {number} n 1–12+ rashi or sign index */
export function signOrdinalHi(n) {
  return hindiDigitOrdinal(n);
}

/** @param {number} house 1–12+ oblique form for “X भाव में”, “X के स्वामी” */
export function houseCountOrdinalHi(house) {
  return hindiDigitOrdinalOblique(house);
}

/** @param {number} house 1–12+ */
export function houseTopicHi(house) {
  return hindiBhavaOrdinal(house);
}
